import { Environment } from "src/interfaces/environment";
import environment from "./environment.json";

export const ENVIRONMENT = ((): Environment => {
  const env = environment.ENV;
  const SUBFUNCTIONALITIES: Environment["SUBFUNCTIONALITIES"] = [];
  if (env.HAS_VIDEO === "true") {
    SUBFUNCTIONALITIES.push("VIDEO");
  }

  return {
    TITLE: env.TITLE,
    API: env.API || null,
    DEBUG: env.DEBUG === "true",
    MAP:
      env.MAP_KEY && env.MAP_ID
        ? {
            ID: env.MAP_ID,
            KEY: env.MAP_KEY,
          }
        : null,
    MSAL: env.MSAL_CLIENT_ID
      ? {
          clientId: env.MSAL_CLIENT_ID,
          authority: env.MSAL_AUTHORITY || undefined,
          tenantId: env.MSAL_TENANT_ID || undefined,
          knownAuthorities: env.MSAL_KNOWN_AUTHORITIES ? env.MSAL_KNOWN_AUTHORITIES.split(",") : undefined,
        }
      : null,
    QR_CHECK_RATE: env.QR_LOGIN_CHECK_RATE ? parseInt(env.QR_LOGIN_CHECK_RATE) : 5000,
    QR_LOGIN: env.QR_LOGIN !== "false",
    QR_REFRESH_RATE: env.QR_LOGIN_REFRESH_RATE ? parseInt(env.QR_LOGIN_REFRESH_RATE) : 60000,
    SUBFUNCTIONALITIES: [],
    WEBSOCKET: env.WEBSOCKET || null,
  };
})();
